<template>
  <v-container class="my-1">
    <v-card>
      <v-card-title class="page-head">
        <div class="ph-left">
          <div class="ph-icon"><v-icon color="#4527a0">mdi-file-chart</v-icon></div>
          <div>
            <div class="ph-title">Reports</div>
            <div class="ph-sub">Generate and print official reports</div>
          </div>
        </div>
      </v-card-title>

      <v-tabs v-model="tab" class="report-tabs" show-arrows>
        <v-tab><v-icon left small>mdi-clipboard-text-outline</v-icon>Child Based</v-tab>
        <v-tab><v-icon left small>mdi-account-heart-outline</v-icon>All Care Givers</v-tab>
        <v-tab><v-icon left small>mdi-human-child</v-icon>All Children</v-tab>
        <v-tab><v-icon left small>mdi-account-arrow-right-outline</v-icon>Assigned Children</v-tab>
        <v-tab><v-icon left small>mdi-chart-box-outline</v-icon>Summary</v-tab>
      </v-tabs>

      <v-card-text class="pa-0">
        <v-tabs-items v-model="tab">
          <!-- Child based report -->
          <v-tab-item>
            <ChildReport />
          </v-tab-item>

          <!-- Care giver based report -->
          <v-tab-item>
            <AllMothersReport />
          </v-tab-item>

        

          <!-- All children list -->
          <v-tab-item>
            <AllChildrenReport />
          </v-tab-item>

          <!-- Assigned children to mothers list -->
          <v-tab-item>
            <AssignedChildrenReport />
          </v-tab-item>

           <!-- Summary report -->
          <v-tab-item>
            <SummaryReport />
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import ChildReport from './ChildReport.vue';
import MotherReport from './MotherReport.vue';
import SummaryReport from './SummaryReport.vue';
import AllChildrenReport from './AllChildrenReport.vue';
import AssignedChildrenReport from './AssignedChildrenReport.vue';
import AllMothersReport from './AllMothersReport.vue';

export default {
  name: 'AssessmentReportIndex',
  components: { ChildReport, MotherReport, SummaryReport, AllChildrenReport, AssignedChildrenReport, AllMothersReport },
  data() {
    return {
      tab: 0,
    };
  },
  methods: {
    printReport() {
      // Simple window.print for now; can be replaced with $htmlToPaper
      window.print();
    },
  },
};
</script>

<style scoped>
@media print {
  .v-application--wrap > *:not(.print-area) {
    display: none !important;
  }
}
</style>
